import React from "react";
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import { useState, useEffect } from "react";
import Timer from "../Timer";

// Fetching Data from the API]

// End

// Page Html
export default function SummarizeMockPage({
  question,
  onInputChange,
  questionNumber,
}) {
  const [text, setText] = useState("");

  // End
  const navigate = useNavigate();

  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);
  };

  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;
  // const [originalWords, setOriginalWords] = useState("");

  const originalWords = mockData.question;

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10"> </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
          Question {questionNumber} of 3
        </h2>
        <p className="p-2 py-8">
          Read the passage and summarize it using one sentence. Type your
          response in the box at the bottom of the screen. You have 10 minutes
          to finish this task. your response will be judge on the quality of
          your writing and on how well your response presents the key points in
          the passage.
        </p>

        <QuestionBox question={originalWords} />
        <div className="font-bold p-2 pt-4 ml-[1250px] ">
          Time left: <Timer initialMinutes={10} initialSeconds={0} />{" "}
        </div>
        <WriteBox onTextChange={handleTextChange} />
      </div>
    </div>
  );
}
